import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { GuardiansProps, username } from "./username";
import { Guardian } from "@/builders/types/guardians";

const get = function (params?: FilterParams) {
  return api.get<{
    count: number;
    next: string;
    previous: string;
    results: Array<Guardian>;
  }>("/guardians", { params });
};

const post = function (data: GuardiansProps) {
  return api.post("/guardians", data);
};

export const guardians = {
  get,
  post,
  username,
};
